import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
} from "./actionTypes"

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  }
}

export const userForgetPasswordSuccess = message => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const CLEAR_FORGET_PASSWORD_MESSAGE = "CLEAR_FORGET_PASSWORD_MESSAGE";

export const clearForgetPasswordMessage = () => ({
  type: CLEAR_FORGET_PASSWORD_MESSAGE,
});

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}
